<template>
  <div class="psui-el-date-card">
    <div class="psui-el-date-card-month-day">
      <span>
        {{ getMonth }}
      </span>
      <span>
        {{ getDay }}
      </span>
    </div>
    
    <span class="psui-el-date-card-year">
      {{ getYearFromDate }}
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  date: {
    type: [Date, String],
    default: new Date(),
  },
})

const getMonth= computed(() => {
  const options = { month: 'short'}
  return new Date(props.date)?.toLocaleString('default', options).replace('.', '')
})

const getDay = computed(() => {
  const options = { day: '2-digit' }
  return new Date(props.date)?.toLocaleString('default', options)
})

const getYearFromDate = computed(() => {
  return new Date(props.date)?.toLocaleString('default', { year: 'numeric' })
})
</script>
